import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DefaultFiltersState } from '@/stores'

import { SetFilterValue } from '../shared.ts'

export interface B2BTableState extends DefaultFiltersState {}

const initialState: B2BTableState = {
  page: 0,
  showCount: 10,
}

const b2bSlice = createSlice({
  name: 'b2b',
  initialState,
  selectors: {
    filters: (state) => ({ page: state.page, showCount: state.showCount, sort: state.sort }),
    resettableStateFilters: (state, filters: (keyof B2BTableState)[]) => filters.map((e) => state[e]),
  },
  reducers: {
    setFilter: (state, action: PayloadAction<SetFilterValue<B2BTableState>>) => {
      return {
        ...state,
        page: action.payload.filterKey !== 'page' ? 0 : state.page,
        [action.payload.filterKey]: action.payload.filterValue,
      }
    },
    resetFilters: (state, action: PayloadAction<(keyof B2BTableState)[]>) => {
      const patch = Object.fromEntries(action.payload.map((key) => [key, initialState[key]]))
      return { ...state, ...patch }
    },
  },
})

export const { reducer: b2bReducer, selectors: b2bSelectors, actions: b2bActions } = b2bSlice
